import update from 'react/lib/update';
import * as actions from './actions';
import { employeeFunctions } from '../../../Globals/constants'

export const getCrewRates = () => {
	var rates = {};
	employeeFunctions.forEach(e=>{
		rates[e.value] = {normalRate: 0, nightRate: 0}
	})
	return rates;
}

export const initState = {
	isLoading: false,
	isStatusOK: true,
	materiels: null,
	crewRates: getCrewRates(),
	stade: false,
	showNotInvoicedOnly: false,
	pCalc: {
		crew: [],
		deliverynotes: [],
		usage: [],
		measurements: [],
		activities: []
	},
	client: null,
	project: null,
	workplaceName: null
}


export default (state = initState, action) => {
	switch (action.type) {
		case actions.INIT_STATE:
			return update(state, {
				$set: initState
		});
		case actions.GET_PCALC_REQUEST:
			return update(state, {
				isLoading: {
					$set: true
				},
				isStatusOK: {
					$set: true
				}
		});
		case actions.GET_PCALC_SUCCESS:
			return update(state, {
				isLoading: {
					$set: false
				},
				isStatusOK: {
					$set: true
				},
				materiels: {
					$set: action.materiels
				},
				pCalc: {
					$set: action.pCalc
				},
				client: {
					$set: action.client
				},
				project: {
					$set: action.project
				},
				workplaceName: {
					$set: action.workplaceName
				},
				stade: {
					$set: action.stade
				},
				showNotInvoicedOnly: {
					$set: action.showNotInvoicedOnly
				}
		});
		case actions.GET_PCALC_PROJECT_SUCCESS:
			return update(state, {
				isLoading: {
					$set: false
				},
				isStatusOK: {
					$set: true
				},
				materiels: {
					$set: action.materiels
				},
				pCalc: {
					$set: action.pCalc
				},
				stade: {
					$set: action.stade
				},
				showNotInvoicedOnly: {
					$set: action.showNotInvoicedOnly
				}
		});
		case actions.GET_PCALC_FAILURE:
			return update(state, {
				isLoading: {
					$set: false
				},
				isStatusOK: {
					$set: false
				}
		});
		case actions.UPDATE_CREW_RATE:
			return update(state, {
				crewRates: {
					[action.functionType]: {
						[action.rateType]: {
							$set: action.val
						}
					}
				}
		});
		case actions.UPDATE_DELIVERYNOTE_PRICE:
			return update(state, {
				pCalc: {
					deliverynotes: {
						[action.index]: {
							price: {
								$set: action.val
							}
						}
					}
				}
		});
		case actions.UPDATE_DELIVERYNOTE_PROCENTAGE:
			return update(state, {
				pCalc: {
					deliverynotes: {
						[action.index]: {
							procentage: {
								$set: action.val
							}
						}
					}
				}
		});
		case actions.UPDATE_MATERIEL_PRICE:
			return update(state, {
				materiels: {
					[action.id]: {
						price: {
							$set: action.val
						}
					}
				}
		});
		case actions.UPDATE_MEASUREMENT_PRICE:
			return update(state, {
				pCalc: {
					measurements: {
						[action.index]: {
							price: {
								$set: action.val
							}
						}
					}
				}
		});
		case actions.UPDATE_ACTIVITIES_PRICE:
			return update(state, {
				pCalc: {
					activities: {
						[action.index]: {
							price: {
								$set: action.val
							}
						}
					}
				}
		});
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/PCalc/reducer.js